import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DepositPageVarsBanner } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { IconSize } from '@freelancer/ui/icon';
import * as Rx from 'rxjs';
import {
  FinopsResult,
  FinopsResultStatus,
} from '../../common/finops-messaging/finops-messaging.types';
import {
  FinopsTrackingSections,
  FinopsTrackingService,
} from '../../common/finops-tracking/finops-tracking.service';
import {
  ApplicationType,
  DepositContext,
  DepositModalItem,
} from '../payments/payments.helpers';

@Component({
  template: `
    <app-payments class="PaymentsModalContainer"
      flTrackingSection="webAppDepositModal"
      [depositContext$]="depositContext$"
      (depositResult)="handleDepositResult($event)"
    ></app-payments>
  `,
  styleUrls: ['./payments-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentsModalComponent implements OnInit {
  IconSize = IconSize;

  depositContext$: Rx.Observable<DepositContext>;

  @Input() backUrl?: string;
  @Input() banner?: DepositPageVarsBanner;
  @Input() chargeAmount: number;
  @Input() chargeCurrencyId: number;
  @Input() items?: DepositModalItem[];
  @Input() trackingToken?: string;
  @Input() checkBalance?: true;

  constructor(
    private modalRef: ModalRef<PaymentsModalComponent>,
    private depositTracking: FinopsTrackingService,
  ) {}

  ngOnInit() {
    this.depositTracking.initiate(FinopsTrackingSections.MODAL);
    this.depositContext$ = Rx.of({
      chargeAmount: this.chargeAmount,
      chargeCurrencyId: this.chargeCurrencyId,
      trackingToken: this.trackingToken,
      banner: this.banner || {},
      items: this.items || [],
      backUrl: this.backUrl,
      applicationType: ApplicationType.DepositModal,
      checkBalance: this.checkBalance || false,
    });
  }

  close(
    depositResult: FinopsResult = {
      finopsStatus: FinopsResultStatus.INTERRUPTED,
    },
  ) {
    // we can pass the whole object if we need to
    this.modalRef.close(depositResult.finopsStatus);
  }

  handleDepositResult(depositResult: FinopsResult) {
    this.close(depositResult);
  }
}
